import { useMemo } from 'react';
import { hasBankLogo, resolveLogo } from './catalog';

export type BankLogoResult = {
  src: string | undefined;
  hasLogo: boolean;
};

const readIsDark = (): boolean =>
  typeof document !== 'undefined' &&
  document.documentElement?.getAttribute('data-theme') === 'dark';

export const useBankLogo = (code: string | undefined | null): BankLogoResult =>
  useMemo(() => {
    if (!hasBankLogo(code)) return { src: undefined, hasLogo: false };
    return { src: resolveLogo(code as string, readIsDark()), hasLogo: true };
  }, [code]);
